// ----------------------------------------------------------------------------
// Snippet: Menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_menu.scss';
import './_menu--dropdown.scss';

const predictiveSearch = '#predictive-search';

// -------------------------------------
// Hooks
// -------------------------------------

function openMenu(menu, focusItem) {
    closeAllMenus(menu.$dropdown);
    // open menu
    menu.$dropdown.addClass('js--isOpen');
    menu.$menuLink.attr('aria-expanded', 'true');

    if (typeof focusItem !== "undefined") {
        // move focus
        focusItem.focus();
    }

    $(predictiveSearch).hide();

    // Trap focus in opened submenu
    trapFocus(menu.$dropdown);
}

function closeMenu(submenu) {
    // close menu
    submenu.$parentDropdown.removeClass('js--isOpen');
    submenu.$parentDropdown.children('.menu__link').attr('aria-expanded', 'false');
    // Release focus trap
    releaseFocusTrap(submenu.$parentDropdown);
}

function closeAllMenus(menuDropdown) {
    menuDropdown.removeClass('js--isOpen');
    menuDropdown.siblings().removeClass('js--isOpen');
    menuDropdown.children('.menu__link').attr('aria-expanded', 'false');
    menuDropdown.siblings().children('.menu__link').attr('aria-expanded', 'false');

    // Release focus trap for all
    releaseFocusTrap(menuDropdown);
    releaseFocusTrap(menuDropdown.siblings());
}

function moveFocusTo(focusItem) {
    focusItem.focus();
}

function moveTabindex(menuDropdown, menuLink) {
    menuDropdown.parents('.menu__list').find('.menu__link').attr('tabindex', '-1');
    menuLink.attr('tabindex', '0');
}

// Store timeout for debouncing menu close
let menuCloseTimeout = null;

function hoverMenu() {
    if ($(window).width() >= 1025) {
        $('.menu__item--dropdown:not(.js--bound)').addClass('js--bound').on('mouseenter mouseleave', allowHoverOnMenu);
    } else {
        $('.menu__item--dropdown.js--bound').removeClass('js--bound').off('mouseenter mouseleave', allowHoverOnMenu);
    }
}

function allowHoverOnMenu(e) {
    e.preventDefault();

    if (e.type === 'mouseenter') {
        // Clear any pending close timeout to prevent flicker
        if (menuCloseTimeout) {
            clearTimeout(menuCloseTimeout);
            menuCloseTimeout = null;
        }

        // Close other open menus immediately
        $('.menu__item--dropdown').not(e.currentTarget).each(function() {
            $(this).removeClass('js--isOpen');
            $(this).children('.menu__link').attr('aria-expanded', 'false');
            $(this).children('.dropdown').attr('hidden', true);
            releaseFocusTrap($(this).children('.dropdown'));
        });

        // Open this menu immediately (no delay)
        $(e.currentTarget).addClass('js--isOpen');
        $(e.currentTarget).children('.menu__link').attr('aria-expanded', 'true');
        $(e.currentTarget).children('.dropdown').removeAttr('hidden');
        $(predictiveSearch).hide();

        // Trap focus on hover open
        trapFocus($(e.currentTarget).children('.dropdown'));
    }

    if (e.type === 'mouseleave') {
        // Delay closing to allow moving between menus
        menuCloseTimeout = setTimeout(function () {
            $(e.currentTarget).removeClass('js--isOpen');
            $(e.currentTarget).children('.menu__link').attr('aria-expanded', 'false');
            $(e.currentTarget).children('.dropdown').attr('hidden', true);

            // Release trap on hover close
            releaseFocusTrap($(e.currentTarget).children('.dropdown'));
            menuCloseTimeout = null;
        }, 150);
    }
}

// Focus trap helper functions
function trapFocus($element) {
    const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
    ];

    const focusableElements = $element.find(focusableSelectors.join(',')).filter(':visible');
    if (focusableElements.length === 0) return;

    const firstFocusable = focusableElements.first();
    const lastFocusable = focusableElements.last();

    // Unbind previous to prevent multiple bindings
    $element.off('keydown.focusTrap');

    $element.on('keydown.focusTrap', function (e) {
        if (e.key === 'Tab') {
            if (e.shiftKey) { // Shift + Tab
                if ($(document.activeElement).is(firstFocusable)) {
                    e.preventDefault();
                    lastFocusable.focus();
                }
            } else { // Tab
                if ($(document.activeElement).is(lastFocusable)) {
                    e.preventDefault();
                    firstFocusable.focus();
                }
            }
        } else if (e.key === 'Escape') {
            // Close menu on Escape
            const $dropdown = $element.closest('.menu__item--dropdown');
            $dropdown.removeClass('js--isOpen');
            $dropdown.children('.menu__link').attr('aria-expanded', 'false').focus();
            $element.attr('hidden', true);
            releaseFocusTrap($element);
        }
    });
}

function releaseFocusTrap($element) {
    $element.off('keydown.focusTrap');
}

$(function () {
    // Opens dropdowns
    $('.menu__item--dropdown > .menu__link').on('click', function (e) {
        e.preventDefault();

        var $dropdown = $(this).closest('.menu__item--dropdown');
        var $menuLink = $(this);
        var $submenu = $dropdown.find('.dropdown').first();
        var isOpen = $dropdown.hasClass('js--isOpen');

        if ($dropdown.siblings().hasClass('js--isOpen')) {
            $dropdown.siblings().removeClass('js--isOpen').children('.menu__link').attr('aria-expanded', 'false');
            $dropdown.siblings().children('.dropdown').attr('hidden', true);
            releaseFocusTrap($dropdown.siblings().children('.dropdown'));

            $dropdown.addClass('js--isOpen');
            $menuLink.attr('aria-expanded', 'true');
            if ($submenu.length) {
                $submenu.removeAttr('hidden');
                trapFocus($submenu);
            }
            $(predictiveSearch).hide();
        } else {
            $dropdown.toggleClass('js--isOpen');
            var expanded = $dropdown.hasClass('js--isOpen');
            $menuLink.attr('aria-expanded', expanded ? 'true' : 'false');
          if ($submenu.length) {
    if (expanded) {
        $submenu.removeAttr('hidden');
        trapFocus($submenu);
        // Set tabindex=0 on all dropdown links to make them tabbable
        $submenu.find('.dropdown__link').attr('tabindex', '0');
    } else {
        $submenu.attr('hidden', true);
        releaseFocusTrap($submenu);
        // Reset tabindex to -1 when submenu closes
        $submenu.find('.dropdown__link').attr('tabindex', '-1');
    }
}

        }
    });

    hoverMenu();
    $(window).on('resize', hoverMenu);

    // ... (rest of your existing keydown handlers unchanged)

    $('.menu__item--dropdown .menu__link').on('click', function (event) {
        event.preventDefault();
    });
});
